export const validMatchupCentreQuery = {
  bool: {
    must: [
      {
        exists: {
          field: 'teamData',
        },
      },
      {
        exists: {
          field: 'marketClassification',
        },
      },
      {
        exists: {
          field: 'marketGenericSequence',
        },
      },
    ],
    filter: [
      {
        terms: {
          marketClassification: ['WIN', 'SPREAD', 'OVER_UNDER', 'SCORE'],
        },
      },
    ],
  },
};
